import React from 'react';
import { styled } from '@mui/material/styles';
import ChatWindowHeader from './ChatWindowHeader/ChatWindowHeader';
import ChatInput from './ChatInput/ChatInput';
import MessageList from './MessageList/MessageList';
import useChatContext from '../../hooks/useChatContext/useChatContext';
import { useAppState } from '../../state';

const ChatWindowContainer = styled('aside', {
  shouldForwardProp: (prop) => prop !== 'isChatWindowOpen',
})<{ isChatWindowOpen: boolean }>(({ theme, isChatWindowOpen }) => ({
  background: '#FFFFFF',
  zIndex: 11,
  display: isChatWindowOpen ? 'flex' : 'none',
  flexDirection: 'column',
  borderLeft: '1px solid #E4E7E9',
  padding: '15px 0px',
  borderTop: '1px solid #E4E7E9',
  [theme.breakpoints.down('sm')]: {
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 100,
  },
}));

// In this component, we are toggling the visibility of the ChatWindow with CSS instead of
// conditionally rendering the component in the DOM. This is done so that the ChatWindow is
// not unmounted while a file upload is in progress.

export default function ChatWindow() {
  const { isChatWindowOpen, messages, conversation } = useChatContext();
  const { meeting } = useAppState();

  return (
    <ChatWindowContainer isChatWindowOpen={isChatWindowOpen}>
      <ChatWindowHeader />
      <MessageList messages={messages} />
      {meeting && Boolean(meeting.isChaperoning) !== true && (<ChatInput conversation={conversation!} isChatWindowOpen={isChatWindowOpen} />)}
    </ChatWindowContainer>
  );
}
